module.exports = __webpack_public_path__ + "static/media/bat4.77a20624.png";